import { FC } from 'react';
import Icon, { iconOptions } from '../Icon';
import styles from './GroupActions.module.scss';
import cx from 'classnames';

export interface ButtonProps {
  label?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  icon?: keyof typeof iconOptions;
  className?: string;
  iconAlignment?: 'left' | 'right';
  theme?: string;
  variant?: string;
  size?: string;
  type?: 'button' | 'submit';
}
const Button: FC<ButtonProps> = ({
  label,
  onClick,
  icon,
  iconAlignment,
  className,
  theme,
  variant = 'solid',
  size = 'default',
  children,
  type = 'button',
}) => {
  let content = [];

  if (icon && !iconAlignment) {
    content.push(<Icon key='icon' size={14} color='inherit' name={icon} />);
  }

  if (label) {
    content.push(<span key='label'>{label}</span>);
  }

  if (icon && iconAlignment === 'right') {
    content.push(<Icon key='icon' size={14} color='inherit' name={icon} />);
  }
  return (
    <button
      type={type}
      className={cx(styles.button, className, styles[size], styles[`theme__${theme}`], styles[variant], {
        [styles['button--icon']]: icon,
        [styles['button--icon--right']]: iconAlignment === 'right',
        [styles['button--icon--only']]: !label,
      })}
      onClick={onClick}
    >
      {children || content}
    </button>
  );
};

export default Button;
